/**
 *
 * @param {String} input
 */
const processGroupDataset = (input) => {
  const clean = input
    .trim()
    .replace(/\s*;\s*/g, ";")
    .replace(/\s*=>\s*/g, "=>");

  return clean;
}

export default processGroupDataset;